import { useRef, useState, type UIEvent } from 'react';

// 카드 폭 300 + 간격 12
const CAROUSEL_PITCH = 312;

/** scroll-snap 위에 버튼만 얹는다(위치는 scrollLeft 에서 읽는다). 무한 순환은 미정(SOT 미해결 5) */
export function useCarousel(count: number) {
  const listRef = useRef<HTMLUListElement>(null);
  const [index, setIndex] = useState(0);
  const lastIndex = count - 1;

  const scrollToIndex = (next: number) => {
    const target = Math.min(Math.max(next, 0), lastIndex);
    listRef.current?.scrollTo({
      left: target * CAROUSEL_PITCH,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'auto'
        : 'smooth',
    });
  };

  return {
    listRef,
    index,
    atStart: index <= 0,
    atEnd: index >= lastIndex,
    onScroll: (event: UIEvent<HTMLUListElement>) =>
      setIndex(Math.round(event.currentTarget.scrollLeft / CAROUSEL_PITCH)),
    scrollPrev: () => scrollToIndex(index - 1),
    scrollNext: () => scrollToIndex(index + 1),
  };
}
